import React, { FC } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import '../../../css/quill_custom.css'

interface QuillEditorProps {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  placeholder?: string
  className?: string
}

interface QuillDisplayProps {
  content: string
  className?: string
}

/**
 * Quillエディタを使用してリッチテキスト編集を行うコンポーネント
 *
 * 使用例:
 * <QuillEditor
 *   value={content}
 *   onChange={setContent}
 *   placeholder="内容を入力してください"
 * />
 */
export const QuillEditor: FC<QuillEditorProps> = ({
  value,
  onChange,
  placeholder,
  className = '',
  onBlur,
}) => {
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: ['', 'center', 'right'] }],
      [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [2, 3, false] }],
      [{ color: [] }, { background: [] }],
      ['link'],
    ],
  }

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'align',
    'size',
    'color',
    'background',
    'link',
  ]

  return (
    <div className={className}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        onBlur={onBlur}
      />
    </div>
  )
}

/**
 * Quillエディタで作成されたHTMLコンテンツを表示するコンポーネント
 *
 * 使用例:
 * <QuillDisplay content={htmlContent} />
 */
export const QuillDisplay: FC<QuillDisplayProps> = ({
  content,
  className = '',
}) => {
  return (
    <div className={'ql-snow'}>
      <div
        className={`ql-editor p-0 ${className}`}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  )
}
